/**
 * Outing Leaderboard Page - Full-screen live leaderboard
 */
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft, Maximize2, Minimize2, Share2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { OutingProvider } from '../context/OutingContext';
import ParSeekerLeaderboard from '../components/ParSeekerLeaderboard';
import LiveNotifications from '../components/LiveNotifications';
import LiveScoreNotifications from '../components/LiveScoreNotifications';
import { toast } from 'sonner';

export default function OutingLeaderboardPage() {
  const { outingId } = useParams();
  const navigate = useNavigate();
  const [fullscreen, setFullscreen] = useState(false);

  const shareLeaderboard = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Live Golf Leaderboard',
          text: 'Check out the live scores!',
          url
        });
      } catch (err) {
        // User cancelled
      }
    } else {
      navigator.clipboard.writeText(url);
      toast.success('Leaderboard link copied!');
    }
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setFullscreen(true);
    } else {
      document.exitFullscreen();
      setFullscreen(false);
    }
  };

  return (
    <OutingProvider>
      <div className={`ps-theme-page min-h-screen ${fullscreen ? '' : 'pb-20'}`} data-testid="outing-leaderboard-theme-page">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#0D1A12] to-[#0A0A0A] border-b border-[#C9A227]/20">
          <div className="flex items-center justify-between p-3">
            <div className="flex items-center gap-3">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate(`/outings/${outingId}`)}
                className="text-zinc-400 hover:text-white"
              >
                <ChevronLeft className="w-6 h-6" />
              </Button>
              <div className="flex items-center gap-2">
                <span className="text-[#C9A227] font-black text-lg">⛳</span>
                <span className="text-[#C9A227] font-black tracking-tight">PAR SEEKER</span>
              </div>
            </div>
            
            <div className="flex items-center gap-2">
              <Button
                variant="ghost"
                size="icon"
                onClick={shareLeaderboard}
                className="text-zinc-400 hover:text-white"
              >
                <Share2 className="w-5 h-5" />
              </Button>
              <Button
                variant="ghost"
                size="icon"
                onClick={toggleFullscreen}
                className="text-zinc-400 hover:text-white"
              >
                {fullscreen ? (
                  <Minimize2 className="w-5 h-5" />
                ) : (
                  <Maximize2 className="w-5 h-5" />
                )}
              </Button>
            </div>
          </div>
        </div>

        {/* Par Seeker Style Leaderboard */}
        <ParSeekerLeaderboard outingId={outingId} refreshInterval={15000} />

        {/* Live Score Notifications */}
        <LiveScoreNotifications outingId={outingId} />
        
        {/* Legacy Live Notifications Overlay */}
        <LiveNotifications outingId={outingId} />
      </div>
    </OutingProvider>
  );
}
